<template>
  <van-popup
    v-model="show"
    position="right"
    closeable
    :style="{ width: '70%', height: '100%' }"
  >
    <div class="pop-inner-box">
      <div class="choose-title">选择桌台</div>
      <van-grid
        :gutter="10"
        :column-num="3"
        class="table-list"
        v-if="openTableList.length > 1"
      >
        <van-grid-item
          v-for="item in openTableList"
          :key="item.TableId"
          :text="item.TableName"
          class="table-item "
          :class="{ checked: selectKeys.includes(item.TableId) }"
          @click="chooseTable(item)"
        >
          <template slot="icon">
            <img class="table-img" src="@/assets/images/chair2.png" alt="" />
            {{ item.Seat }}
          </template>
        </van-grid-item>
      </van-grid>

      <van-cell v-else-if="openTableList.length == 1 && type != 3">
        <label class="label-width"> 当前桌台：</label
        >{{ currentItem.TableName }}
      </van-cell>
      <van-field
        v-model="num"
        type="digit"
        label="改价"
        v-if="type == 1"
        clearable
      />
      <van-cell title="退菜数量" v-else-if="type == 2">
        <template slot="default">
          <van-stepper v-model="num" :min="0" :max="maxNum" />
        </template>
      </van-cell>
      <van-button class="sure-btn" type="info" block @click="onSubmit"
        >确定</van-button
      >
    </div>
  </van-popup>
</template>

<script>
import "./restarant.less";
// import restaurantApi from "@/api/restaurant.js";
import restaurantManageApi from "@/api/restaurantManage.js";
// import { mapState } from "vuex";
import {
  Cell,
  CellGroup,
  Button,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Card,
  Popup,
  Grid,
  GridItem,
  Field,
  Dialog,
  Icon,
  Stepper,
  Notify,
} from "vant";
// import { ls } from "@/utils/cache.js";
export default {
  name: "TableOperate",
  components: {
    [Dialog.Component.name]: Dialog.Component,
    [Field.name]: Field,
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    [Card.name]: Card,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Button.name]: Button,
    [GoodsAction.name]: GoodsAction,
    [GoodsActionIcon.name]: GoodsActionIcon,
    [GoodsActionButton.name]: GoodsActionButton,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Stepper.name]: Stepper,
  },
  props: {
    dishTables: {
      type: Array,
      default: () => [],
    },
    orderId: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      show: false,
      selectKeys: [],
      type: 1,
      openTableList: [],
      num: 1,
      minNum: 0,
      maxNum: 1,
      currentItem: {},
    };
  },
  // computed: {
  //   ...mapState({
  //     restaruantInfo: state => state.user.restaruantInfo
  //   })
  // },
  created() {},
  methods: {
    onShow(current, type) {
      this.show = true;
      this.type = type;
      this.currentItem = current;
      this.openTableList = this.dishTables.filter(el => el.OrderStatus != 2);
      if (this.type == 4) {
        //反结结账桌台
        this.openTableList = this.dishTables.filter(el => el.OrderStatus == 2);
      }
      this.selectKeys = this.openTableList.map(v => v.TableId);
      if (this.type == 1) {
        //改价
        this.num = this.currentItem.UnitPrice;
        this.maxNum = 10000;
        this.minNum = 0;
      } else if (type == 2) {
        //退菜
        this.num = 1;
        this.maxNum = this.currentItem.Quantity;
        this.minNum = 1;
      }
    },
    chooseTable(item) {
      if (this.selectKeys.includes(item.TableId)) {
        this.selectKeys = this.selectKeys.filter(el => el != item.TableId);
      } else {
        this.selectKeys.push(item.TableId);
      }
    },
    onSubmit() {
      if (this.selectKeys && !this.selectKeys.length) {
        Notify("请选择桌台");
        return false;
      }
      if (this.type == 1 || this.type == 2) {
        let accountItemIds = [];
        this.openTableList.forEach(el => {
          if (this.selectKeys.includes(el.TableId)) {
            const data = el.DishAccounts.filter(
              item =>
                item.BatchId == this.currentItem.BatchId &&
                item.AccountItemId == this.currentItem.AccountItemId,
            );
            if (data && data.length) {
              const ids = data.map(v => v.Id);
              accountItemIds = accountItemIds.concat(ids);
            }
          }
        });

        if (this.type == 1) {
          //改价
          restaurantManageApi
            .editPrice({
              AccountIds: accountItemIds,
              UnitPrice: this.num,
            })
            .then(() => {
              this.afterSubmit();
            })
            .catch(() => {
              this.afterSubmit();
            });
        } else if (this.type == 2) {
          //退菜
          restaurantManageApi
            .returnDish({
              AccountIds: accountItemIds,
              Num: -this.num,
            })
            .then(() => {
              this.afterSubmit();
            })
            .catch(() => {
              this.afterSubmit();
            });
        }
      } else if (this.type == 3) {
        this.$router.push({
          name: "restarantManageCheckout",
          query: {
            orderId: this.orderId,
            tableIds: this.selectKeys.join(","),
          },
        });
      } else if (this.type == 4) {
        this.$emit("submit", this.selectKeys);
      }
    },
    afterSubmit() {
      Notify({ type: "success", message: "操作成功" });
      this.show = false;
      this.$emit("update");
    },
  },
};
</script>
<style lang="less" scoped>
.pop-inner-box {
  height: 100vh;
  overflow-y: auto;
  .label-width {
    width: 2.4rem;
    display: inline-block;
  }
  .sure-btn {
    width: 90%;
    margin: 20px 5%;
  }
  .choose-title {
    padding: 10px;
    background: #fafafa;
    margin-bottom: 10px;
  }
  .table-list {
    padding-bottom: 10px;
    .table-item {
      margin-bottom: 5px;
      /deep/.van-grid-item__content--center {
        border: 1px solid transparent;
      }
      &.checked {
        /deep/.van-grid-item__content--center {
          border: 1px solid #f20;
          background: #fffafa;
        }
      }
    }
  }
}
</style>
